import { Type } from '@sinclair/typebox';

export function createPathGuidParameter<Name extends string>(name: Name) {
    return {
        name,
        in: 'path',
        required: true,
        schema: Type.String({ format: 'uuid' }),
    } as const;
}

export function createPathStringParameter<Name extends string>(name: Name) {
    return {
        name,
        in: 'path',
        required: true,
        schema: Type.String(),
    } as const;
}
